import { useId } from 'react';
import { ResponsiveContainer, AreaChart, Area } from 'recharts';

/**
 * Mini area chart pra exibir tendência dentro dos KPI cards.
 * Sem axis, sem labels, sem tooltip — só o "shape" da tendência.
 */
export function Sparkline({ data, color = '#6366f1', height = 40, animated = true }) {
  const gradientId = useId();
  if (!data || data.length === 0) return null;

  return (
    <div style={{ width: '100%', height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 4, right: 0, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.4} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={2}
            fill={`url(#${gradientId})`}
            isAnimationActive={animated}
            animationDuration={900}
            animationEasing="ease-out"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

export default Sparkline;
